import { TranslatePipe , TranslateService } from '@ngx-translate/core';
import { ChangeDetectorRef , Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringTranslate',
  pure: false
})
export class TranslationPipe extends TranslatePipe implements PipeTransform {
  constructor( translate: TranslateService,  _ref: ChangeDetectorRef) {
    super(translate, _ref);
  }
  transform(value: any): any {
    if(value){
      if (typeof(value) === 'string') {
        // DF keeps form item label as is if it starts from '##'
        const cleanValue = value.indexOf('##') === 0 ? value.slice(2) : value;
        const transformValue = super.transform(cleanValue, []);

        // it may be that the translated value is a parent-entry that points to a whole object in the
        //  translation table. in that case, return the origin value and not the translated object.
        //  See: GEN-88203
        if (typeof(transformValue) === 'string') {
            return transformValue;
        }
      }
      return value;
    }
    return '';
  }
}
